<template>
	<div
		v-if="switcherEnable"
		class="domains-switcher"
		:class="{ 'domains-switcher--om': isOM }"
		@click="switchDomain"
	>
		<img
			:src="icon"
			class="domains-switcher__icon"
			:alt="`icon-${domainText}`"
		/>
		<span class="domains-switcher__text">
			{{ domainText }}
		</span>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { getDomainSwitcherTargetUrl } from '@/utils/domainUrls'
// Icons
import TicketIcon from '@/assets/images/ic_ticket_icon.svg'
import MenuIcon from '@/assets/images/ic_menu_icon.svg'

export default {
	name: 'DomainsSwitcher',

	props: {
		title: {
			type: String,
			default: 'Order Here'
		},

		subTitle: {
			type: String,
			default: 'Online Menu'
		}
	},

	computed: {
		...mapState('venue', ['venueInfo']),

		icon() {
			return this.isOM ? TicketIcon : MenuIcon
		},

		switcherEnable() {
			return getDomainSwitcherTargetUrl(this.venueInfo, this.$route.params)
		},

		isOM() {
			return Boolean(this.venueInfo.ticketsUrl)
		},

		domainText() {
			return this.isOM ? 'Event calendar' : 'Menu'
		}
	},

	methods: {
		switchDomain() {
			const targetUrl = getDomainSwitcherTargetUrl(
				this.venueInfo,
				this.$route.params
			)
			if (!targetUrl) {
				return
			}

			window.location.href = targetUrl
		}
	}
}
</script>

<style scoped lang="scss">
@import './src/assets/styles/variables';

.domains-switcher {
	position: absolute;
	left: 0;
	top: 0;
	display: flex;
	align-items: center;
	color: $white;
	border: 1px solid CurrentColor;
	margin: 8px auto 8px 8px;
	padding: 8px;
	font-size: 16px;
	white-space: nowrap;
	cursor: pointer;
	border-radius: 6px;
	transition: background-color 0.3s;
	&--icon {
		width: 20px;
		height: auto;
	}
	&--pink {
		margin-right: 0;
		position: static;
		padding: 14px 14px 14px 14px;
		border-color: $neon-magenta;
		background-color: rgba($neon-magenta, 0.25);

		&:hover {
			background-color: rgba($neon-magenta, 0.5);
		}
	}
	&__text {
		display: inline-block;
		margin-left: 6px;
		color: $white;
	}

	&--om {
		z-index: 10;
	}
}
</style>
